// src/utils/puzzleValidation.ts
// Note: zod package needs to be installed first: npm install zod
// Temporarily using basic validation until zod is installed

export interface PuzzleData {
    difficulty: 'easy' | 'medium' | 'hard';
    fen: string;
    first_move: string;
    result: 'win' | 'draw' | 'lose';
    solved?: 'yes' | 'no' | '';
}

export interface DailyPuzzles {
    easy: PuzzleData;
    medium: PuzzleData;
    hard: PuzzleData;
}

// Basic validation function (replace with Zod when installed)
export function validatePuzzleData(data: unknown): DailyPuzzles {
    if (!data || typeof data !== 'object') {
        throw new Error('Invalid puzzle data: not an object');
    }

    const puzzleData = data as Record<string, unknown>;

    const difficulties = ['easy', 'medium', 'hard'] as const;

    for (const diff of difficulties) {
        if (!(diff in puzzleData) || typeof puzzleData[diff] !== 'object') {
            throw new Error(`Missing or invalid ${diff} difficulty`);
        }

        const puzzle = puzzleData[diff] as Record<string, unknown>;

        if (!puzzle.fen || typeof puzzle.fen !== 'string') {
            throw new Error(`Invalid FEN string for ${diff}`);
        }
        if (!puzzle.first_move || typeof puzzle.first_move !== 'string') {
            throw new Error(`Invalid first_move for ${diff}`);
        }
        if (!puzzle.difficulty || typeof puzzle.difficulty !== 'string') {
            throw new Error(`Invalid difficulty for ${diff}`);
        }
        if (!puzzle.result || typeof puzzle.result !== 'string') {
            throw new Error(`Invalid result for ${diff}`);
        }
    }

    return data as DailyPuzzles;
}
